<div>
  <ion-item-divider *ngIf="!this.selectedJobPost || (this.selectedJobPost && !this.selectedJobPost.jobpostId)" style="height:60px">New Job Post</ion-item-divider>
  <ion-item-divider *ngIf="this.selectedJobPost && this.selectedJobPost.jobpostId" style="height:60px" class="ion-text-wrap">
    {{formData['jobtitle']}} (posted {{formData['datereceived'] | nucampdate: 'MM/DD/YYYY' }})
  </ion-item-divider>
  <form novalidate autocomplete="off">
    <ion-row *ngIf="isAdmin">
      <ion-col size="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap">
          <ion-label position="stacked">Status:</ion-label>
          <ion-select required [(ngModel)]="formData['status']" name="status" type="text">
            <ion-select-option value="in-review">In Review</ion-select-option>
            <ion-select-option value="posted">Posted</ion-select-option>
            <ion-select-option value="declined">Declined</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col size="8" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap">
          <ion-label position="stacked">Reason (if declined):</ion-label>
          <ion-input required [(ngModel)]="formData['reasonfordeclined']" name="reasonfordeclined" type="text"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-lg="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['personname']">
          <ion-label position="stacked"><ng-container *ngIf='!isGraduate'>Your </ng-container>Full Name:</ion-label>
          <ion-input required [(ngModel)]="formData['personname']" name="personname" type="text" (ionFocus)="browseJob()"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-lg="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['personemail'] || !validEmail(formData['personemail'])">
          <ion-label position="stacked"><ng-container *ngIf='!isGraduate'>Your </ng-container>Email:</ion-label>
          <ion-input required [(ngModel)]="formData['personemail']" name="personemail" type="text" (ionFocus)="browseJob()"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-lg="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['companyname']">
          <ion-label position="stacked"><ng-container *ngIf='!isGraduate'>Your </ng-container>Company Name:</ion-label>
          <ion-input required [(ngModel)]="formData['companyname']" name="companyname" type="text" (ionFocus)="browseJob()"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-lg="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap">
          <ion-label position="stacked">Contact Name (if different):</ion-label>
          <ion-input required [(ngModel)]="formData['jobcontactname']" name="jobcontactname" type="text"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-lg="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="formData['jobcontactemail'] && !validEmail(formData['jobcontactemail'])">
          <ion-label position="stacked">Contact Email (if different):</ion-label>
          <ion-input required [(ngModel)]="formData['jobcontactemail']" name="jobcontactemail" type="text"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-lg="4" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap">
          <ion-label position="stacked">Contact Phone Number (optional):</ion-label>
          <ion-input required [(ngModel)]="formData['jobcontactphone']" name="jobcontactjobcontactphone" type="text"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-lg="6" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['jobtitle']">
          <ion-label position="stacked">Title of the Job Opportunity:</ion-label>
          <ion-input required [(ngModel)]="formData['jobtitle']" name="jobtitle" type="text"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-lg="6" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['joblocation']">
          <ion-label position="stacked">Job Location (city or list of cities, remote...):</ion-label>
          <ion-input required [(ngModel)]="formData['joblocation']" name="joblocation" type="text"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['jobdescription']">
          <ion-label position="stacked">Job Description (Summary):</ion-label>
          <ion-textarea required minlength="10" tappable rows="10" [(ngModel)]="formData['jobdescription']" name="jobdescription" type="text"></ion-textarea>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-lg="6" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['jobtype']">
          <ion-label position="stacked">Type of Job (part-time, full-time, internship, other):</ion-label>
          <ion-input required [(ngModel)]="formData['jobtype']" name="jobtype" type="text"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" size-lg="6" class="ion-padding">
        <ion-item mode="md" class="ion-text-wrap" [class.notfilled]="!formData['joburl']">
          <ion-label position="stacked">Job Application Website (url):</ion-label>
          <ion-input required [(ngModel)]="formData['joburl']" name="joburl" type="text"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="ion-text-center ion-padding-vertical">
        <ion-button (click)="submitForm()" data-cy="submitjob" *ngIf="formData.status !== 'posted' || isAdmin" [disabled]="!formData.personname || !formData.personemail || !formData.jobtitle || !formData.jobtype || !formData.jobdescription || !formData.joblocation" type="submit"  color="primary">
          <ng-container *ngIf="formData.jobpostId && formData.status !== 'posted' || isAdmin">Update</ng-container>
          <ng-container *ngIf="!formData.jobpostId">Submit</ng-container>
        </ion-button>
        <ng-container *ngIf="formData.jobpostId && formData.status === 'posted' && !isAdmin">
          <ion-button disabled type="submit"  color="success">Posted!</ion-button>
        </ng-container>
        <img *ngIf="submitted" height="1" width="1" style="display:none;" alt="LinkedIn Pixel" src="https://px.ads.linkedin.com/collect/?pid=2623268&conversionId=3056988&fmt=gif" />
      </ion-col>
    </ion-row>
  </form>
</div>
